import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Paper,
  Box,
  useTheme,
} from '@mui/material';
import dayjs from 'dayjs';
import { tokens } from '../../theme';
import { formatCNPJ } from '../redscore';
import { useTranslation } from '../../hooks/useTranslation';

const ConsultTable = ({
  data,
  filteredData,
  showFiltered,
  page,
  rowsPerPage,
  onPageChange,
  onRowsPerPageChange,
  onRowClick,
}) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const { t } = useTranslation();

  const displayData = showFiltered ? filteredData : data;
  const paginatedData = displayData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);

  if (!data || data.length === 0) {
    return (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          minHeight: '400px',
          color: colors.grey[400],
        }}
      >
        {t('messages.searchingData')}
      </Box>
    );
  }

  return (
    <Box>
      <TableContainer
        component={Paper}
        sx={{
          boxShadow: 'none',
          border: `1px solid #EAEAEA`,
          borderRadius: '8px',
        }}
      >
        <Table>
          <TableHead>
            <TableRow>
              <TableCell
                sx={{
                  fontSize: '16px',
                  fontWeight: '700',
                  color: colors.grey[200],
                  borderBottom: `1px solid ${colors.primary[400]}`,
                }}
              >
                {t('consultation.agroscore').toUpperCase()}
              </TableCell>
              <TableCell
                sx={{
                  fontSize: '16px',
                  fontWeight: '700',
                  color: colors.grey[200],
                  borderBottom: `1px solid ${colors.primary[400]}`,
                }}
              >
                {t('consultation.consultResponsible')}
              </TableCell>
              <TableCell
                sx={{
                  fontSize: '16px',
                  fontWeight: '700',
                  color: colors.grey[200],
                  borderBottom: `1px solid ${colors.primary[400]}`,
                }}
              >
                {t('consultation.clientName')}
              </TableCell>
              <TableCell
                sx={{
                  fontSize: '16px',
                  fontWeight: '700',
                  color: colors.grey[200],
                  borderBottom: `1px solid ${colors.primary[400]}`,
                }}
              >
                {t('consultation.document')}
              </TableCell>
              <TableCell
                sx={{
                  fontSize: '16px',
                  fontWeight: '700',
                  color: colors.grey[200],
                  borderBottom: `1px solid ${colors.primary[400]}`,
                }}
              >
                {t('consultation.consultDate')}
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {paginatedData.map((row, index) => (
              <TableRow
                key={row.id}
                hover
                onClick={() => onRowClick(row)}
                sx={{
                  cursor: 'pointer',
                  '&:hover': {
                    backgroundColor: colors.primary[400],
                  },
                  transition: 'background-color 0.2s ease',
                }}
              >
                <TableCell
                  sx={{
                    fontSize: '18px',
                    fontWeight: 'bold',
                    borderBottom: `1px solid ${colors.primary[400]}`,
                  }}
                >
                  {Math.floor(row.score)}
                </TableCell>
                <TableCell
                  sx={{
                    fontSize: '15px',
                    fontWeight: 600,
                    color: colors.grey[700],
                    borderBottom: `1px solid ${colors.primary[400]}`,
                  }}
                >
                  {row.company.name}
                </TableCell>
                <TableCell
                  sx={{
                    fontSize: '15px',
                    fontWeight: 600,
                    color: colors.grey[700],
                    borderBottom: `1px solid ${colors.primary[400]}`,
                  }}
                >
                  {row.customerData?.full_name?.toUpperCase()}
                </TableCell>
                <TableCell
                  sx={{
                    fontSize: '15px',
                    fontWeight: 600,
                    color: colors.grey[700],
                    borderBottom: `1px solid ${colors.primary[400]}`,
                  }}
                >
                  {formatCNPJ(row.customerData.taxvar)}
                </TableCell>
                <TableCell
                  sx={{
                    fontSize: '15px',
                    fontWeight: 600,
                    color: colors.grey[700],
                    borderBottom: `1px solid ${colors.primary[400]}`,
                  }}
                >
                  {dayjs(row.created_at).format('DD/MM/YYYY, HH:mm')}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      <TablePagination
        rowsPerPageOptions={[5, 10, 25]}
        component="div"
        count={displayData.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={onPageChange}
        onRowsPerPageChange={onRowsPerPageChange}
        labelRowsPerPage="Linhas por pagina"
        labelDisplayedRows={({ from, to, count }) => `${from}-${to} de ${count}`}
      />
    </Box>
  );
};

export default ConsultTable;
